module.exports = __webpack_public_path__ + "img/master-implementer.5524dad9.svg";